<template>
  <div>
    <div class="section">
      <button class="button">
        <router-link :to="{ name: 'edit-parent-category-create' }">Add Parent Category</router-link>
      </button>
    </div>
    <div class="columns" v-for="parentCategory in parentCategories" :key="parentCategory.id">
      <span class="column">{{ parentCategory.name }}</span>
      <span class="column">
        <router-link :to="{ path: '/edit-parent-category/' + parentCategory.id}">Edit</router-link>
      </span>
    </div>
  </div>
</template>

<script>
const PARENT_CATEGORIES_COLLECTION = "ParentCategories";
import { firestore } from "@/firebase";

export default {
  data() {
    return {
      parentCategories: []
    };
  },
  mounted() {
    firestore.collection(PARENT_CATEGORIES_COLLECTION).onSnapshot(snapshot => {
      let parentCategories = snapshot.docs.map(d => {
        var data = d.data();
        data.id = d.id;
        return data;
      });
      this.parentCategories = parentCategories;
    });
  }
};
</script>